import type { Router } from "vue-router";
import { buildOrgUrl } from "@/utils/navigation/orgUrl";
import { usePageMetaStore } from "@/store/pageMeta.store";
import { useAuthenticationStore } from "@/store/authentication.store";

type Customer = {
  allMsps?: boolean;
  allCustomers?: boolean;
  uuid?: string;
};

type SelectedAccount = {
  type_name?: string;
  name?: string;
  uuid?: string;
} | null;

type SelectCustomerHandlerDeps = {
  customer: Customer;
  selectedAccount: SelectedAccount;
  setCustomer: (customer: Customer) => void;
  router: Router;
  routePath: string;
};

export const selectCustomerHandler = async ({
  customer,
  selectedAccount,
  setCustomer,
  router,
  routePath,
}: SelectCustomerHandlerDeps) => {
  setCustomer(customer);

  const authStore = useAuthenticationStore();
  const selectedUuid =
    selectedAccount?.uuid || authStore.selectedAccount?.uuid || null;
  const selectedMspUuid = authStore.selectedMsp?.uuid || null;

  if (customer.allMsps && selectedAccount?.type_name === "System") {
    try {
      await authStore.setMspUser(null);
    } catch {
      // handled centrally via axios interceptors
    }

    usePageMetaStore().setMSP("");
    await router
      .push(buildOrgUrl("system", selectedUuid, "dashboard"))
      .catch(() => {});
    return;
  }

  if (customer.allCustomers) {
    await router.push(buildOrgUrl("msp", selectedMspUuid, "customers"));
    return;
  }

  if (customer.allMsps && selectedAccount?.type_name === "MSP") {
    await router.push(buildOrgUrl("msp", selectedUuid, "customers"));
    return;
  }

  if (routePath !== "/customer/email_security/overview") {
    const targetUuid = customer.uuid || selectedUuid || undefined;
    await router.push(buildOrgUrl("customer", targetUuid, ""));
  }
};
